import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageIntro from '@/components/feature/PageIntro';
import CTASection from '@/components/feature/CTASection';
import { services, supplyImage } from '@/mocks/home';
import { processSteps } from '@/mocks/pages';

export default function ServicesPage() {
  return (
    <>
      <Navbar />
      <main className="bg-background-50 pt-16 md:pt-20">
        <PageIntro crumb="Supply Services" eyebrow="Supply Services" title="MORE THAN COMPONENTS." docTitle="Supply Services | NORTHLINE Flow Systems">
          <p>We help connect industrial requirements with suitable valves, flow-control components and sourcing support.</p>
        </PageIntro>

        <section className="max-w-[1200px] mx-auto px-5 md:px-10 pb-20 md:pb-28">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
            <div className="lg:col-span-5">
              <div data-mo="image" className="w-full h-[360px] md:h-[520px] lg:h-[600px] rounded-lg overflow-hidden bg-background-100">
                <img src={supplyImage} alt="Engineer reviewing valve datasheets - NORTHLINE supply services" title="NORTHLINE supply services" className="w-full h-full object-cover object-top" />
              </div>
            </div>
            <div data-mo="group" className="lg:col-span-7">
              {services.map((s) => (
                <article key={s.no} className="grid grid-cols-[48px_1fr] md:grid-cols-[64px_1fr] py-8 border-t border-background-200 first:border-t-0 first:pt-0">
                  <span className="eyebrow text-primary-500 pt-1">{s.no}</span>
                  <div>
                    <h2 className="font-heading text-2xl md:text-3xl tracking-[-0.02em] text-foreground-950">{s.title}</h2>
                    <p className="mt-3 t-body text-foreground-600 max-w-md">{s.body}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-background-100/60">
          <div className="max-w-[1200px] mx-auto px-5 md:px-10 py-20 md:py-28">
            <p className="eyebrow text-primary-500">How we work</p>
            <h2 data-mo="title" className="mt-5 font-heading text-3xl md:text-4xl tracking-[-0.02em] text-foreground-950 max-w-2xl">From requirement to order, one coordinated path.</h2>
            <ol data-mo="group" className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
              {processSteps.map((s, i) => (
                <li key={s.title} className="border-t border-foreground-950/80 pt-6">
                  <div className="flex items-center justify-between">
                    <span className="font-label text-xs text-primary-500">0{i + 1}</span>
                    {i < processSteps.length - 1 && <i className="ri-arrow-right-line text-foreground-400 hidden lg:block" />}
                  </div>
                  <h3 className="mt-4 text-lg font-medium text-foreground-950">{s.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.body}</p>
                </li>
              ))}
            </ol>
          </div>
        </section>

        <div className="pt-20 md:pt-28" />
        <CTASection title="LET'S FIND THE RIGHT COMPONENTS." secondary={{ label: 'Browse Products', to: '/products' }} />
      </main>
      <Footer />
    </>
  );
}